export default __webpack_public_path__ + "static/media/AAVE.7a37d675.svg";